document.addEventListener('DOMContentLoaded', function () {
  const json = JSON.parse(document.querySelector('#product-variant').innerHTML);
  console.log(json)
  const metas = JSON.parse(document.querySelector('#variant-metas').innerHTML);
  // Select the node you want to observe
  const targetNode = document.querySelector('.product__info-container');
  let swatchNode = null

  function matchSwatch() {
    const allSwatch = swatchNode.querySelectorAll('.swatch-view-item');

    allSwatch.forEach((swatch) => {
      const label = swatch.getAttribute('orig-value');
      const targetVariant = json.find((variant) => variant.title === label);

      if (metas[targetVariant?.id]) {
        const node = document.createElement('div')
        node.innerHTML = 'NEW'
        node.classList.add('swatch-new')

        swatch.appendChild(node)
      }
    })
  }

  // Create a new instance of MutationObserver
  const observer = new MutationObserver((mutationsList, observer) => {
    // Handle the mutations here
    for (let mutation of mutationsList) {
      // Check if the target node has been added or removed
      if (mutation.type === 'childList') {
        // Handle the changes to the target node
        if (targetNode.querySelector('variant-swatch-king') && !swatchNode) {
          swatchNode = targetNode.querySelector('variant-swatch-king');
          observer.disconnect();
          matchSwatch()
        }
        // Do something with the changes
      }
    }
  });

  // Configure the observer to listen for changes to the target node
  const config = { childList: true, subtree: true };

  // Start observing the target node
  observer.observe(targetNode, config);
});
